import { render, staticRenderFns } from "./ClassCreateDetails.vue?vue&type=template&id=02c6e7fa&scoped=true&"
import script from "./ClassCreateDetails.vue?vue&type=script&lang=js&"
export * from "./ClassCreateDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClassCreateDetails.vue?vue&type=style&index=0&id=02c6e7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6e7fa",
  null
  
)

export default component.exports